/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listTeamNotificationPoliciesParamsQueryMax = 100;

export const listTeamNotificationPoliciesParamsLimitOneRegExp = new RegExp(
  '^(?:0*(?:[1-9][0-9]?|100))$',
);
export const listTeamNotificationPoliciesParamsLimitTwoMax = 100;

export const listTeamNotificationPoliciesParamsLimitDefault = 50;
export const listTeamNotificationPoliciesParamsCursorMax = 2000;

export const ListTeamNotificationPoliciesParams = zod.object({
  query: zod.string().max(listTeamNotificationPoliciesParamsQueryMax).optional(),
  limit: zod
    .union([
      zod.string().regex(listTeamNotificationPoliciesParamsLimitOneRegExp),
      zod.int().min(1).max(listTeamNotificationPoliciesParamsLimitTwoMax),
    ])
    .default(listTeamNotificationPoliciesParamsLimitDefault),
  cursor: zod.string().min(1).max(listTeamNotificationPoliciesParamsCursorMax).optional(),
});

export type ListTeamNotificationPoliciesParams = zod.input<
  typeof ListTeamNotificationPoliciesParams
>;
export type ListTeamNotificationPoliciesParamsOutput = zod.output<
  typeof ListTeamNotificationPoliciesParams
>;
